module.exports = __webpack_public_path__ + "img/vue-crud-lg.6287cf88.png";